<template> </template>

<script>
import billingApi from '@/api/billing'

export default {
  name: 'PaymentScreen',
  props: {
    value: Boolean,
    subscription: Object
  },
  mounted() {},
  watch: {
    value(newVal, oldVal) {
      if (newVal) {
        this.show()
      }
    }
  },
  methods: {
    show() {
      const vm = this
      billingApi
        .saveTemp(
          this.$store.getters['user/currentCampaign'].project_id,
          this.subscription
        )
        .then(function(temp) {
          const d = temp.data.results
          d.successCallback = function(data) {
            vm.$emit('planUpdateSuccess', data)
          }
          d.closeCallback = function(closeData) {
            console.log(closeData)
            billingApi
              .cancelTemp(
                vm.$store.getters['user/currentCampaign'].project_id,
                vm.subscription
              )
              .then(function(data) {
                vm.$emit('planUpdateFail', closeData)
              })
          }
          Paddle.Checkout.open(d)
        })
    }
  }
}
</script>

<style scoped></style>
